'use client'

import { ListingCard } from '@/components/marketing/content/listing-card'
import { ListingGrid } from '@/components/marketing/content/listing-grid'
import { track } from '@/lib/analytics/track'

interface UseCase {
  slug: string
  title: string
  description: string
  tags: string[]
  coverImage?: string
}

export function UseCasesListing({ useCases }: { useCases: UseCase[] }) {
  return (
    <ListingGrid columns={2}>
      {useCases.map((uc, index) => (
        <ListingCard
          key={uc.slug}
          href={`/use-cases/${uc.slug}`}
          title={uc.title}
          description={uc.description}
          category={uc.tags[0]}
          image={uc.coverImage}
          onClick={() =>
            track('usecases_card_click', {
              slug: uc.slug,
              position: index + 1,
            })
          }
        />
      ))}
    </ListingGrid>
  )
}
